import { defineStore } from 'pinia'

export const useSidebarStore = defineStore({
    id: 'sidebar',
    state: () => ({
        isSidebarOpen: true
    }),
    actions: {
        toggleSidebar() {
            this.isSidebarOpen = !this.isSidebarOpen
        }
    }
})
